import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-viewcustomfrom',
  templateUrl: './viewcustomfrom.component.html',
  styleUrls: ['./viewcustomfrom.component.css']
})
export class ViewcustomfromComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  searchValue(e:any){
    
  }
}
